import { InjectionToken } from "@angular/core";

export interface IKeyValueStore {
  get<T>(key: string): Promise<T | null>;
  set<T>(key: string, value: T): Promise<void>;
  remove(key: string): Promise<void>;
  clear(): Promise<void>;
}

export const MOBILE_KEY_VALUE_STORE = new InjectionToken<IKeyValueStore>("MOBILE_KEY_VALUE_STORE");
